import { css } from "@emotion/css";

export const createSubtaskItemStyles = () => {
  return {
    subtaskButton: css({
      appearance: "none",
      outline: "none",
      border: "none",
      cursor: "pointer",
    }),
  };
};
